import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { useMerchantPos } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/hooks/useMerchantPos';
import {
  MainResidenceForm as MainResidence,
  MainResidenceFormProps,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/MainResidence/components/MainResidenceForm';

export const MainResidenceForm = ({ fieldVariant, fullWidth, direction }: MainResidenceFormProps) => {
  const { currency } = useMerchantPos();

  return (
    <FormSectionWrapper titleTid="MAIN_RESIDENCE">
      <MainResidence currency={currency} fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction} />
    </FormSectionWrapper>
  );
};
